const log = require("../shared_utils/log.js");
module.exports = function store(state, emitter) {
  function deselectAll(e) {
    const parent = e.target.parentNode;
    if (!parent || !parent.classList) {
      return;
    }
    if (
      parent.classList.contains("top-row") ||
      parent.classList.contains("main-row") ||
      parent.id === "app" ||
      parent.tagName.toLowerCase() === "html"
    ) {
      emitter.emit("deselect-all");
    }
  }

  function endDrag(e) {
    emitter.emit("complete-drag-action", e);
    emitter.emit("cleanup-drag");
  }

  function playKeyDown(e) {
    if (!(e.target.tagName.toUpperCase() === "INPUT")) {
      if (e.key === "Delete" || e.key === "Backspace") {
        if (state.selectedGlitchApplicationId) {
          emitter.emit("drop-to-trash");
        } else if (state.selectedGlitchId) {
          // remove glitch from toolbar
          emitter.emit("remove-glitch-from-toolbar", state.selectedGlitchId);
        } else {
          emitter.emit("delete-selected-sprite");
        }
      } else if (e.key === "Enter" && state.selectedTargetId) {
        emitter.emit("duplicate-selected-sprite");
      } else {
        emitter.emit("play-key-down", e);
      }
    }
  }

  function playKeyUp(e) {
    emitter.emit("play-key-up", e);
  }

  emitter.on("play-key-up", (event) => {
    log("play-key-up", event);
    if (state.isGamePlaying) {
      state.vm.postIOData("keyboard", { key: event.key, isDown: false });
    }
  });

  emitter.on("key-pressed-game-playing", (key) => {
    log("key-pressed-game-playing", key);
  });

  emitter.on("key-pressed-game-paused", (key) => {
    log("key-pressed-game-paused", key);
  });

  emitter.on("play-key-down", (event) => {
    log("play-key-down", event);
    if (state.isGamePlaying) {
      state.vm.postIOData("keyboard", { key: event.key, isDown: true });
      emitter.emit("key-pressed-game-playing", event.key);
    } else {
      emitter.emit("key-pressed-game-paused", event.key);
    }
  });
  emitter.on("play-mouse-move", (e) => {
    const rect = state.canvas.getBoundingClientRect();
    const coordinates = {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
      canvasWidth: rect.width,
      canvasHeight: rect.height,
    };
    state.vm.postIOData("mouse", coordinates);
  });

  emitter.on("play-mouse-down", (e) => {
    const rect = state.canvas.getBoundingClientRect();
    const data = {
      isDown: true,
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
      canvasWidth: rect.width,
      canvasHeight: rect.height,
    };
    state.vm.postIOData("mouse", data);
  });

  emitter.on("play-mouse-up", (e) => {
    const rect = state.canvas.getBoundingClientRect();
    const data = {
      isDown: false,
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
      canvasWidth: rect.width,
      canvasHeight: rect.height,
    };
    state.vm.postIOData("mouse", data);
  });
  emitter.on("add-document-event-listeners", () => {
    document.addEventListener("mousedown", deselectAll);
    document.addEventListener("mouseup", endDrag);
    document.addEventListener("keydown", playKeyDown);
    document.addEventListener("keyup", playKeyUp);

    window.addEventListener("beforeunload", handleBeforeUnload);
  });

  function handleBeforeUnload(e) {
    const confirmationMessage = "Are you sure you want to leave this page?";
    (e || window.event).returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // Display message in some browsers
  }

  emitter.on("remove-document-event-listeners", () => {
    document.removeEventListener("mousedown", deselectAll);
    document.removeEventListener("mouseup", endDrag);
    document.removeEventListener("keydown", playKeyDown);
    document.removeEventListener("keyup", playKeyUp);

    // Remove beforeunload listener
    window.removeEventListener("beforeunload", handleBeforeUnload);

    // Trigger beforeunload manually if back button is pressed (optional)
    if (window.history.state && window.history.state.triggeredByBackButton) {
      const event = new Event("beforeunload");
      window.dispatchEvent(event);
    }
  });

  // Handle back button navigation (optional enhancement)
  window.addEventListener("popstate", (event) => {
    if (event.state) {
      const event = new Event("beforeunload");
      window.dispatchEvent(event);

      // Optionally, remove listeners here if needed
      emitter.emit("remove-document-event-listeners");
    }
  });
};
